import { PayrollIssuesTableIssueFragment } from 'generated/resources/graphql'

import type { Value } from 'modules/core/components/MultiFilters/hooks/utils/defaultEvaluators'

type Issue = PayrollIssuesTableIssueFragment

export default (issue: Issue, fieldName: Value) => {
  const employee = issue.employee

  if (!employee) {
    return true
  }

  switch (fieldName) {
    case 'employee_status':
      return employee

    case 'employee_name':
      return employee.fullName

    case 'location':
      return employee.locationId

    case 'team':
      return employee.teamIds

    case 'legal_entity':
      return employee.legalEntity?.id
  }
}
